// React and routing
import { useNavigate } from "react-router-dom";

// Redux
import { useDispatch } from "react-redux";
import { logoutAction } from "../../redux/actions/logout";

// API
import { logout } from "../../api/authentication";

// AI assistant conversation (kept in sessionStorage)
import { clearAiConversationStorage } from "components/AiAssistant/aiStore";

const useLogout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = async () => {
    try {
      // Get refresh token from localStorage
      const refresh = localStorage.getItem("refresh");
      if (refresh) {
        // Call API to invalidate token on server
        await logout(JSON.parse(refresh));
      }

      // Clear Redux state
      dispatch(logoutAction());

      // Clear localStorage
      localStorage.clear();
      clearAiConversationStorage();

      // Redirect to login page
      navigate("/login");

      return { success: true };
    } catch (error) {
      console.error("Logout error:", error);

      // Even if the API call fails, we should still clear local state
      // and redirect the user to login
      dispatch(logoutAction());

      localStorage.clear();
      clearAiConversationStorage();
      navigate("/login");

      return { success: true, error };
    }
  };

  return { handleLogout };
};

export default useLogout;
